/**
 * Глобальные переменные проекта.
 * @module Variables
 */

/**
 * Брейкпоинты проекта.
 * @typedef {Object} Breakpoints
 *
 * @property {Number} mobile    Брейкпоинт на 480.
 * @property {Number} mobileLg  Брейкпоинт на 640.
 * @property {Number} tablet    Брейкпоинт на 768.
 * @property {Number} tabletLg  Брейкпоинт на 1024.
 * @property {Number} desktop   Брейкпоинт на 1280.
 * @property {Number} desktopLg Брейкпоинт на 1600.
 * @property {Number} desktopXl Брейкпоинт на 1920.
 */

/**
 * Брейкпоинты проекта.
 * @type {Breakpoints}
 */
const breakpoints = {
    mobile: 480,
    mobileLg: 640,
    tablet: 768,
    tabletLg: 1024,
    desktop: 1280,
    desktopLg: 1600,
    desktopXl: 1920,
};

export default breakpoints;
